import { FeedbackContext } from '@/components/feedback/FeedbackPanel';

const normalizeCreationMethod = (raw: unknown): string | undefined => {
  if (raw == null) return undefined;
  const lower = String(raw).toLowerCase().trim();
  if (!lower) return undefined;

  const canonical = lower.replace(/[\s-]+/g, '_');

  if (['auto_generated', 'autogenerated', 'automated', 'auto'].includes(canonical)) {
    return 'auto_generated';
  }
  if (['ai_generated', 'aigenerated', 'ai_assisted', 'aiassisted', 'ai'].includes(canonical)) {
    return 'ai_generated';
  }
  if (['manual', 'manually_created', 'handmade', 'hand_made'].includes(canonical)) {
    return 'manual';
  }
  if (canonical === 'hybrid') {
    return 'hybrid';
  }

  return canonical;
};

export const getNormalizedCreationMethod = (mealPlanData?: any): string | undefined => {
  if (!mealPlanData) return undefined;

  const rawMethod =
    (mealPlanData as any)?.creationMethod ||
    (mealPlanData as any)?.creation_method ||
    (mealPlanData as any)?.creationType ||
    (mealPlanData as any)?.creation_type ||
    (mealPlanData as any)?.generationType ||
    (mealPlanData as any)?.generation_type ||
    (mealPlanData as any)?.planMetadata?.creationMethod ||
    (mealPlanData as any)?.planMetadata?.creationType ||
    (mealPlanData as any)?.planMetadata?.generationType ||
    (mealPlanData?.searchParams as any)?.creationMethod ||
    (mealPlanData?.searchParams as any)?.creationType ||
    (mealPlanData?.searchParams as any)?.generationType;

  return normalizeCreationMethod(rawMethod);
};

export const getPlanningFeedbackContext = (
  normalizedMethod: string | undefined,
  contexts: {
    manual: FeedbackContext;
    ai: FeedbackContext;
    auto: FeedbackContext;
    fallback: FeedbackContext;
  }
): FeedbackContext => {
  switch (normalizedMethod) {
    case 'manual':
      return contexts.manual;
    case 'ai_generated':
      return contexts.ai;
    case 'auto_generated':
      return contexts.auto;
    default:
      return contexts.fallback;
  }
};
